'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {
    return _react2.default.createElement(
        'dl',
        null,
        _react2.default.createElement(
            'dt',
            null,
            '\u5BA2\u6237\u7F16\u53F7\uFF1A'
        ),
        _react2.default.createElement(
            'dd',
            null,
            props.id
        ),
        _react2.default.createElement('br', null),
        _react2.default.createElement(
            'dt',
            null,
            '\u5BA2\u6237\u540D\u79F0\uFF1A'
        ),
        _react2.default.createElement(
            'dd',
            null,
            props.name
        ),
        _react2.default.createElement('br', null),
        _react2.default.createElement(
            'dt',
            null,
            '\u5BA2\u6237\u7B49\u7EA7\uFF1A'
        ),
        _react2.default.createElement(
            'dd',
            null,
            props.level
        ),
        _react2.default.createElement('br', null),
        _react2.default.createElement(
            'dt',
            null,
            '\u8D1F\u8D23\u4EBA\u59D3\u540D\uFF1A'
        ),
        _react2.default.createElement(
            'dd',
            null,
            props.manager
        ),
        _react2.default.createElement('br', null),
        _react2.default.createElement(
            'dt',
            null,
            '\u8D1F\u8D23\u4EBA\u624B\u673A\u53F7\uFF1A'
        ),
        _react2.default.createElement(
            'dd',
            null,
            props.mobile
        ),
        _react2.default.createElement('br', null),
        _react2.default.createElement(
            'dt',
            null,
            '\u5BA2\u6237\u72B6\u6001\uFF1A'
        ),
        _react2.default.createElement(
            'dd',
            null,
            props.status
        ),
        _react2.default.createElement('br', null),
        _react2.default.createElement(
            'dt',
            null,
            '\u521B\u5EFA\u65F6\u95F4\uFF1A'
        ),
        _react2.default.createElement(
            'dd',
            null,
            props.created_at
        )
    );
};


//////////////////
// WEBPACK FOOTER
// ./src/js/components/user_bio.js
// module id = 1326
// module chunks = 0